import React, {Component} from 'react';
import Box from '@material-ui/core/Box';
import I18n from "amn/ui/i18n/I18n";
import {I18N_NS_STANDARDS} from "amn/common/i18n/I18nextConfig";

type Props = {
  ml?: number;
  mr?: number;
  mt?: number;
  mb?: number;
};

class NewBadge extends Component<Props> {
  static defaultProps = {
    ml: 1
  };

  render() {
    const {ml, mr, mt, mb} = this.props;
    
    return (
      <Box ml={ml}
           mr={mr}
           mt={mt}
           mb={mb}
           px={1}
           py={0.25}
           fontSize={10}
           fontWeight="fontWeightBold"
           bgcolor="secondary.main"
           color="secondary.contrastText"
           borderRadius="borderRadius">
        <I18n>
          New
        </I18n>
      </Box>
    );
  }
}

export default NewBadge;
